<template>
    <svg version="1.2"
         class="inline"
         xmlns="http://www.w3.org/2000/svg"
         xmlns:xlink="http://www.w3.org/1999/xlink"
         overflow="visible"
         preserveAspectRatio="none"
         viewBox="0 0 24 24"
         width="18"
         height="18">
        <g>
            <path xmlns:default="http://www.w3.org/2000/svg" d="M6 18l8.5-6L6 6v12zM16 6v12h2V6h-2z" style="fill: rgb(94, 94, 94);" vector-effect="non-scaling-stroke"/>
        </g>
    </svg>
</template>

<script>
    export default {
        name: "RightArrowSVG"
    }
</script>

<style scoped>

</style>